import Vue from 'vue'
import router from 'vue-router'
import Layout from '../views/layout/Layout'
import LayoutT from '../views/layout/LayoutT'
import LayoutM from '../views/layout/LayoutM'
import LayoutS from '../views/layout/LayoutS'
import LayoutE from '../views/layout/LayoutE'
import LayoutR from '../views/layout/LayoutR'
import LayoutDemo from '../views/layout/LayoutDemo'
import LayoutCharge from '../views/layout/LayoutCharge'
import langLayout from '../views/layout/langLayout'
import LayoutEv from '../views/layout/LayoutEv'

Vue.use(router)

// export default {
//   router: [
//     {
//       path: '/',
//       component: HelloWorld
//     }
//   ]
// }

export const constantRouterMap = [
  {
    path: '/index',
    component: () => import('@/views/portal/index'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D仿真实验室'
      next()
    }
  },
  {
    path: '/demonstration',
    component: () => import('@/views/portal/demonstration'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D仿真实验室'
      next()
    }
  },
  {
    path: '/infoTenant',
    component: () => import('@/views/portal/infoTenant'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D虚拟仿真实验室'
      next()
    }
  },
  {
    path: '/party',
    component: () => import('@/views/portal/party'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D虚拟仿真实验室'
      next()
    }
  },
  {
    path: '/partyM',
    component: () => import('@/views/portal/partyM'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D虚拟仿真实验室'
      next()
    }
  },
  {
    path: '/partyLC',
    component: () => import('@/views/portal/partyLC'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D虚拟仿真实验室'
      next()
    }
  },
  {
    path: '/partyLCAH',
    component: () => import('@/views/portal/partyLCAH'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D虚拟仿真实验室'
      next()
    }
  },
  {
    path: '/partyZY',
    component: () => import('@/views/portal/partyZY'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D虚拟仿真实验室'
      next()
    }
  },
  {
    path: '/partyHN',
    component: () => import('@/views/portal/partyHN'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D虚拟仿真实验室'
      next()
    }
  },
  {
    path: '/authZB',
    component: () => import('@/views/portal/authZB'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D仿真实验室'
      next()
    }
  },
  {
    path: '/authZBInfo',
    component: () => import('@/views/portal/authZBInfo'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D仿真实验室'
      next()
    }
  },
  {
    path: '/authZBLoginOut',
    component: () => import('@/views/portal/authZBLoginOut'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D仿真实验室'
      next()
    }
  },

  {
    path: '/BS',
    component: () => import('@/views/portal/BS'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D虚拟仿真实验室'
      next()
    }
  },
  // no token
  {
    path: '/threeParty',
    component: () => import('@/views/portal/threePartyLogin'),
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D虚拟仿真实验室'
      next()
    }
  },
  // 单个用户
  {
    path: '/',
    component: Layout,
    redirect: 'Layout',
    children: [
      {
        path: '/',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/layout/components/AppMain')
      },
      {
        path: '/info',
        name: 'Binfo',
        component: () => import('@/views/layout/components/Binfo')
      },
      {
        path: '/TJinfo',
        name: 'TJinfo',
        component: () => import('@/views/layout/components/TJinfo')
      },
      {
        path: '/personal',
        component: () => import('@/views/layout/components/Personal')
      }
    ]
  },
  // 同步路由
  {
    path: '/synchronization',
    component: LayoutS,
    redirect: 'LayoutS',
    children: [
      {
        path: '/',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/layout/components/AppMainS')
      },
      {
        path: '/infoS',
        name: 'BinfoS',
        component: () => import('@/views/layout/components/BinfoS')
      },
      {
        path: '/personal',
        component: () => import('@/views/layout/components/Personal')
      }
    ]
  },
  // 探究路由
  {
    path: '/explore',
    component: LayoutE,
    redirect: 'LayoutE',
    children: [
      {
        path: '/',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/layout/components/AppMainE')
      },
      {
        path: '/TJinfoE',
        name: 'TJinfoE',
        component: () => import('@/views/layout/components/TJinfoE')
      },
      {
        path: '/personal',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/layout/components/Personal')
      }
    ]
  },
  // 租户
  {
    path: '/tenant',
    component: LayoutT,
    redirect: 'LayoutT',
    beforeEnter: (to, from, next) => {
      document.getElementById('titleId').innerHTML = '3D虚拟仿真实验室'
      next()
    },
    children: [
      {
        path: '/',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/layout/components/AppMainT')
      },
      {
        path: '/Cinfo',
        name: 'Cinfo',
        component: () => import('@/views/layout/components/Cinfo')
      },
      {
        path: '/CinfoTj',
        name: 'CinfoTj',
        component: () => import('@/views/layout/components/CinfoTj')
      },
      {
        path: '/personalT',
        component: () => import('@/views/layout/components/PersonalT')
      }
    ]
  },
  // 演示版本
  {
    path: '/demo',
    component: LayoutDemo,
    redirect: 'LayoutDemo',
    children: [
      {
        path: '/',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/layout/components/AppMainDemo')
      },
      {
        path: '/demoInfo',
        component: () => import('@/views/layout/components/demoInfo')
      },
      {
        path: '/demoTJInfo',
        component: () => import('@/views/layout/components/demoTJInfo')
      },
      {
        path: '/personalDemo',
        component: () => import('@/views/layout/components/personalDemo')
      }
    ]
  },
  // 收费版本
  {
    path: '/expand',
    component: LayoutCharge,
    redirect: 'LayoutCharge',
    children: [
      {
        path: '/',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/layout/components/AppMainCharge')
      },
      {
        path: '/expandInfo',
        component: () => import('@/views/layout/components/chargeInfo')
      },
      {
        path: '/expandTJInfo',
        component: () => import('@/views/layout/components/chargeTJInfo')
      },
      {
        path: '/personalExpand',
        component: () => import('@/views/layout/components/personalCharge')
      }
    ]
  },
  // 我的实验路由
  {
    path: '/myEx',
    component: LayoutM,
    redirect: 'LayoutM',
    children: [
      {
        path: '/',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/layout/components/AppMainM')
      },
      {
        path: '/Myinfo',
        component: () => import('@/views/layout/components/Myinfo')
      },
    ]
  },
  // 回收站
  {
    path: '/recycle',
    component: LayoutR,
    redirect: 'LayoutR',
    children: [
      {
        path: '/',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/layout/components/AppMainR')
      },
    ]
  },
  // 考评系统
  {
    path: '/evaluation',
    component: LayoutEv,
    redirect: 'LayoutEv',
    children: [
      {
        path: '/',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/layout/components/AppMainEv')
      },
    ]
  },
  // 临时英文版
  {
    path: '/en',
    component: langLayout,
    redirect: 'langLayout',
    children: [
      {
        path: '/En',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/layout/components/langEn')
      },
      {
        path: '/infoEn',
        name: 'BinfoEn',
        component: () => import('@/views/layout/components/BinfoEn')
      },
      {
        path: '/personalEn',
        component: () => import('@/views/layout/components/PersonalEn')
      }
    ]
  },
]

export default new router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js